<template>
  <v-form ref="loginForm" v-model="valid" lazy-validation @submit.prevent="signIn">
    <v-text-field
      v-model="loginEmail"
      :rules="loginEmailRules"
      label="E-mail"
      type="email"
      name="email"
      autocomplete="username"
      variant="outlined"
      density="comfortable"
      rounded="lg"
      prepend-inner-icon="mdi-email-outline"
      class="mb-2"
      required
    ></v-text-field>

    <v-text-field
      v-model="loginPassword"
      :append-inner-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
      :rules="[rules.required]"
      :type="show1 ? 'text' : 'password'"
      name="input-10-1"
      label="Senha"
      autocomplete="current-password"
      variant="outlined"
      density="comfortable"
      rounded="lg"
      prepend-inner-icon="mdi-lock-outline"
      @click:append-inner="show1 = !show1"
      @keyup.enter="signIn"
    ></v-text-field>

    <v-btn
      type="submit"
      block
      size="large"
      color="#CF122E"
      rounded="lg"
      :loading="isLoading"
      class="mt-2 text-none text-white font-weight-bold"
    >
      Entrar
    </v-btn>
  </v-form>
</template>

<script>

import { mapActions } from 'vuex';

export default {
  data: () => ({
    isLoading: false,
    valid: true,
    loginPassword: '',
    loginEmail: '',
    loginEmailRules: [
      (v) => !!v || 'Campo obrigatório.',
      (v) => /.+@.+\..+/.test(v) || 'Favor inserir um e-mail válido.',
    ],
    show1: false,
    rules: {
      required: (value) => !!value || 'Campo obrigatório.',
    },
  }),

  methods: {
    ...mapActions('user', ['login']),

    async signIn() {
      const { valid } = await this.$refs.loginForm.validate();
      if (valid) {

        this.isLoading = true;
        const { success } = await this.login({
          email: this.loginEmail.toLowerCase(),
          password: this.loginPassword,
        });
        this.isLoading = false;

        if (success) {
          this.$emit('login-success');
          return this.$router.push({ name: 'RequestView' });
        } else {
          this.$emit('login-fail');
        }
      }
    },

    reset() {
      this.$refs.loginForm.reset();
    },

    resetValidation() {
      this.$refs.loginForm.resetValidation();
    },
  }
}
</script>
